/**
 * @description 参训统计title组件
 * @author xyguo
 * @date 2021-7-26
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
// import ClassResultPercent  from './classResultPercent'
import { component_tool, framework_tool, utils_tool } from '@/tool'
let {
  WizCard,
  WizBizcharts,
  WizRow,
  WizCol,
  WizTypography
} = component_tool;
let { WizContainer } = framework_tool;
const { Title, Text, Paragraph } = WizTypography

class OrgRemoteEvaluation extends WizContainer {

    componentName = 'orgRemoteEvaluation';

    constructor(props){
        super(props);
        this.state={
        }
      }

      /**
     * 头部：名称
     */
    _header = ( title, value) => {
      return (
           <WizRow style={{padding:0,marginLeft:"50px"}}>
            <WizCol span={8}>
              <Text strong >
                  {title[0]}：{value[0]}
             </Text>
            </WizCol>
            <WizCol span={6}>
              <Text strong >
                  {title[1]}：{value[1]}
                </Text>
            </WizCol>
            <WizCol span={10}>
              <Text strong >
                  {title[2]}：{value[2]}
                </Text>
            </WizCol>
          </WizRow>
      )
  };

    _render() {
      const {name ,remoteAuthName,startToEndDateStr} = this.props;
      let title = ['检核场次','检核项目','检核时间'];
      let value = name ?[
        name,
        remoteAuthName,
        startToEndDateStr]
            :['','',''];
        return [
            <WizCard title={'检核详情'} key={new Date().getTime()} bodyStyle={{paddingLeft:20,paddingBottom:25,paddingTop:25}}>
                {this._header(title,value)}
            </WizCard>
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
       
    };
};

export default connect(mapStateToProps)(OrgRemoteEvaluation);
